<script setup>
const ct = useCommonUiTranslation()

import {systemProtocolArticlePath} from '~/utils/systemProtocols'
defineProps({url: {type: String, required: true}})
</script>
<template>
  <a class="system-protocol-link" :href="systemProtocolArticlePath(url)" target="_blank" rel="noopener" @click.stop><slot>{{ ct('查看协议') }}</slot></a>
</template>
<style scoped>
.system-protocol-link {display: inline-block; color: var(--el-color-primary); font-size: 12px; padding: 6px 0; text-decoration: underline;}
</style>
